'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var gold7 = exports.gold7 = '#E8722C';
var gold6 = exports.gold6 = '#EF8A23';
var gold5 = exports.gold5 = '#F5A11B';
var gold4 = exports.gold4 = '#FCB913';
var gold3 = exports.gold3 = '#FDC434';
var gold2 = exports.gold2 = '#FED059';
var gold1 = exports.gold1 = '#FFDD7F';
var gold = {
  7: gold7,
  6: gold6,
  5: gold5,
  4: gold4,
  3: gold3,
  2: gold2,
  1: gold1
};
exports.default = gold;